
export function clearCanvas(canvas) {
  canvas.width = canvas.width;
}

export function clearContext(context ) {
  clearCanvas(context.canvas);
}

export function fillContext(context ) {
  const { canvas } = context;
  context.fillRect( 0, 0, canvas.width, canvas.height );
}

export function setLineDash(context,array) {
  if( context.setLineDash ) {
    context.setLineDash(array);
  }
  else { // Firefox
    context.mozDash = array;
  }
}

export function moveTo(context,point,transform) {
  const p = transform ? transform.apply(point) : point;
  context.moveTo(p.x,p.y);
}

export function lineTo(context,point,transform) {
  const p = transform ? transform.apply(point) : point;
  context.lineTo(p.x,p.y);
}

export function strokeSegment(context,from,to,transform) {
  context.beginPath();
  moveTo(context,from,transform);
  lineTo(context,to  ,transform);
  context.stroke();
}

export function strokeWireframe(context ) {
  context.lineJoin = 'round';
  context.strokeStyle = '#f4f4f4';
  context.lineWidth = 1.5;
  context.stroke();

  context.strokeStyle = '#141446'; // in the server... '#9999CC';
  context.lineWidth = 1;
  context.stroke();
}

export function dot(context,center,radius,transform,fillStyle,strokeStyle,lineWidth) {
  const c = transform ? transform.apply(center) : center;
  if( fillStyle ) {
    context.fillStyle = fillStyle;
  }
  if( strokeStyle ) {
    context.strokeStyle = strokeStyle;
  }
  if( lineWidth !== undefined ) {
    context.lineWidth = lineWidth;
  }
  context.beginPath();
  context.arc(c.x, c.y, radius, 0, 2 * Math.PI, false);
  if( strokeStyle ) {
    context.stroke();
  }
  context.fill();
}

export function strokeDot(context,center,radius,transform,strokeStyle) {
  const c = transform ? transform.apply(center) : center;
  if( strokeStyle ) {
    context.strokeStyle = strokeStyle;
  }
  context.beginPath();
  context.arc(c.x, c.y, radius, 0, 2 * Math.PI, false);
  context.stroke();
}

export function strokeCross(context,center,radius,transform,strokeStyle) {
  const c = transform ? transform.apply(center) : center;
  if( strokeStyle ) {
    context.strokeStyle = strokeStyle;
  }
  context.beginPath();
  context.moveTo(c.x-radius,c.y-radius); context.lineTo(c.x+radius,c.y+radius);
  context.moveTo(c.x-radius,c.y+radius); context.lineTo(c.x+radius,c.y-radius);
  context.stroke();
}



/** WEBPACK FOOTER **
 ** ./src/gear/canvas.js
 **/